/**
 * The region tree's rule (spec 2026-10-02 hierarki, 4.1), one table for the device and the
 * server: a dekenat holds paroki, a paroki holds stasi and lingkungan (the lingkungan of the
 * parish centre, "Pusat paroki"), a stasi holds lingkungan, a lingkungan holds nothing. A
 * dekenat hangs off nothing, and so may a paroki outside any dekenat. The diocese has no
 * wilayah level (removed 2026-10-02). Administrasi offers only what the rule allows
 * (`ANAK_UNIT`, the preselected kind first) and the push route refuses the rest
 * (apps/api/src/routes/sync/unit.ts). Pure.
 */
import { JENIS_UNIT } from './schema/contract'

export type JenisUnit = (typeof JENIS_UNIT)[number]

/** The kinds a unit may hold, the preselected one first: under a paroki, Lingkungan before Stasi. */
export const ANAK_UNIT: Readonly<Record<JenisUnit, readonly JenisUnit[]>> = {
  dekenat: ['paroki'],
  paroki: ['lingkungan', 'stasi'],
  stasi: ['lingkungan'],
  lingkungan: [],
}

/** The kinds a unit may hang off. */
export const INDUK_UNIT: Readonly<Record<JenisUnit, readonly JenisUnit[]>> = {
  dekenat: [],
  paroki: ['dekenat'],
  stasi: ['paroki'],
  lingkungan: ['paroki', 'stasi'],
}

export function adalahJenisUnit(nilai: unknown): nilai is JenisUnit {
  return typeof nilai === 'string' && (JENIS_UNIT as readonly string[]).includes(nilai)
}

/**
 * May a unit of `jenis` hang off a parent of `jenisInduk` (null: no parent)? Only kinds the
 * tree holds: never a wilayah, never a unit under one.
 */
export function bolehDiBawah(jenis: unknown, jenisInduk: unknown): boolean {
  if (!adalahJenisUnit(jenis)) return false
  if (jenisInduk === null) return jenis === 'dekenat' || jenis === 'paroki'
  return adalahJenisUnit(jenisInduk) && INDUK_UNIT[jenis].includes(jenisInduk)
}
